import { useEffect, useRef, useState } from 'preact/hooks';
import { useConsent } from '../lib/consent';
import { useI18n } from '../i18n';

export function CookieBanner() {
  const { consent, accept, decline, openLegal } = useConsent();
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const shownOnce = useRef(false);

  useEffect(() => {
    if (consent !== null) {
      setVisible(false);
      return;
    }
    // Initial load: delay 800ms so it doesn't flash on first paint.
    // Subsequent resets (hasShown already): appear immediately.
    if (shownOnce.current) {
      setVisible(true);
      return;
    }
    const id = setTimeout(() => {
      shownOnce.current = true;
      setVisible(true);
    }, 800);
    return () => clearTimeout(id);
  }, [consent]);

  if (!visible || consent !== null) return null;

  return (
    <div class="cookie-banner" role="dialog" aria-live="polite" aria-label={t('cookie.title')}>
      <div class="cookie-inner">
        <div class="cookie-top">
          <div class="cookie-icon" aria-hidden="true">🍪</div>
          <div>
            <h3>{t('cookie.title')}</h3>
            <p>{t('cookie.message')}</p>
          </div>
        </div>
        <div class="cookie-actions">
          <button class="cookie-btn accept" onClick={accept}>
            {t('cookie.accept')}
          </button>
          <button class="cookie-btn decline" onClick={decline}>
            {t('cookie.decline')}
          </button>
          <button
            class="cookie-btn info"
            onClick={() => openLegal('privacy')}
            title={t('cookie.info')}
            aria-label={t('cookie.info')}
          >
            ⓘ
          </button>
        </div>
      </div>
    </div>
  );
}
